import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";

interface SelectGenreType {
  genre: string;
}

const SelectGenreForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SelectGenreType>({
    defaultValues: {
      genre: "",
    },
  });

  const [detailInfo, setDetailInfo] = useRecoilState(writingDetailInfoAtom);
  const [flow, setFlow] = useRecoilState(formFlowAtom);

  const onValid = (data: SelectGenreType) => {
    console.log("Selected Genre:", data.genre);
    setDetailInfo({ ...detailInfo, genre: data.genre });
    setFlow(2);
  };

  const onInvalid = (errors: any) => {
    console.log("Errors:", errors);
  };

  return (
    <div>
      <div className="text-xl font-bold mb-4">장르를 선택하세요</div>
      <form onSubmit={handleSubmit(onValid, onInvalid)}>
        {/* 장르 선택 */}
        <div className="mb-4">
          <label htmlFor="genre" className="block text-gray-500 font-medium">
            장르
          </label>
          <select
            id="genre"
            {...register("genre", { required: "장르를 선택해주세요!" })}
            className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
          >
            <option value="">-- 장르를 선택하세요 --</option>
            <option value="article">기사</option>
            <option value="report">보고서</option>
            <option value="essay">에세이</option>
            <option value="letter">편지</option>
            <option value="novel">소설</option>
            <option value="poem">시</option>
            <option value="play">희곡</option>
            <option value="fairy_tale">동화</option>
            <option value="prose">수필</option>
            <option value="biography">전기</option>
            <option value="scenario">시나리오</option>
          </select>
          {errors.genre && (
            <p className="text-red-500 mt-2">{errors.genre.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          다음
        </button>
      </form>
    </div>
  );
};

export default SelectGenreForm;
